@if (filtersForm()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    [title]="title()"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    class="last-reception-filter filter-body"
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <mat-form-field class="recent mr-6" id="unit-input-form" appearance="outline">
      <mat-label>Time span</mat-label>
      <mat-select
        #selectInput
        [formControlName]="recentUnit()"
        [value]="filtersForm().get(recentUnit())?.value"
      >
        <mat-option value="after">after</mat-option>
        <mat-option value="before">before</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="last-reception" appearance="outline">
      <mat-label>Date</mat-label>
      <input
        autocomplete="off"
        matInput
        (focus)="tplutcFrom.open()"
        (dateChange)="onDateChange($event)"
        [matDatepicker]="tplutcFrom"
        class="datepicker"
        [formControlName]="utcFrom()"
      />
      <mat-datepicker-toggle matSuffix [for]="tplutcFrom"></mat-datepicker-toggle>
      <mat-datepicker #tplutcFrom></mat-datepicker>
    </mat-form-field>
  </div>
}
